import getCurrentDate from "@/helpers/getCurrentDate";

export default function School(options) {
  this.schooljaar = options.schooljaar || "";
  this.brincode = options.brincode || "";
  this.xsdversie = "2.3";
  this.aanmaakdatum = options.aanmaakdatum || getCurrentDate();
  this.dependancecode = options.dependancecode || "";
}
